import { render, staticRenderFns } from "./_userAction.vue?vue&type=template&id=2d90c9c2&"
import script from "./_userAction.vue?vue&type=script&lang=ts&"
export * from "./_userAction.vue?vue&type=script&lang=ts&"
import style0 from "./_userAction.vue?vue&type=style&index=0&id=2d90c9c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileAvatar: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/profile/ProfileAvatar.vue').default,CommunityFollowBtn: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/community/CommunityFollowBtn.vue').default,DiagramLikeBtn: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/diagram/DiagramLikeBtn.vue').default,DiagramForkBtn: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/diagram/DiagramForkBtn.vue').default,DiagramTags: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/diagram/DiagramTags.vue').default,CommunitySocialShare: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/community/CommunitySocialShare.vue').default,CommunityCardGrid: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/community/CommunityCardGrid.vue').default})
